function changeSelectedCategory(type) {
    const recipesList = document.getElementById("recipes-list");
    const breakfast = document.getElementById("recipe-category-breakfast");
    const entree = document.getElementById("recipe-category-entree");
    const snack = document.getElementById("recipe-category-snacks");
    const dessert = document.getElementById("recipe-category-dessert");

    switch (type) {
      case "breakfast":
        breakfast.classList.add("active");
        entree.classList.remove("active");
        snack.classList.remove("active");
        dessert.classList.remove("active");

        // Adding Breakfast Recipes
        recipesList.innerHTML = `<div class="breakfast-recipes">
      <h4 class="accordion-breakfast">Kodo Millet Paniyaram</h4>
      <div class="accordion-content-breakfast">
      <img
      src="https://cdn.shopify.com/s/files/1/0509/7993/0283/files/Kodo-Millet-and-Quinoa-Panniyaram_jpg_1of_5.jpg?v=1630405652"
      alt="Kodo Millet Paniyaram"
      />
      <p class="accordion-recipe-title">Ingredients - For the Batter</p>
      <ul>
      <li>1 cup <a href="/products/pearled-kodo-millet">Bliss Tree’s Kodo Millet</a></li>
      <li>1/4 cup <a href="/products/whole-urad-dal-white">Bliss Tree’s Urad Dal</a></li>
      <li>1 tsp Fenugreek Seeds</li>
      <li>1 tsp Salt</li>
      <li>Cooking Oil</li>
      </ul>
      <br />
      <p class="accordion-recipe-title">Ingredients - For the Masala</p>
      <ul>
      <li>1 cup Onions finely chopped</li>
      <li>2 – 3 Green Chillies</li>
      <li>1/2 cup Carrot grated</li>
      <li>3 tbsp Bliss Tree’s Coriander Leaves</li>
      <li>1/2 tsp Mustard Seeds</li>
      <li>1/4 cup <a href="/products/whole-urad-dal-white">Bliss Tree’s Urad Dal</a></li>
      <li>4-5 Curry Leaves</li>
      <li>1/2 tsp Cumin Seeds</li>
      <li>1/2 tsp Chana Dal</li>
      <li>5 Cashew Nuts broken</li>
      <li>Salt to taste</li>
      <li>Cooking Oil</li>
      </ul>
      <br />
      <p class="accordion-recipe-title">Instructions - For the Batter</p>
      <p>
      Wash the millets and urad dal with fenugreek seeds in water separately for at least 3 to 4 hours.
      </p>
      <p>
      Drain completely and grind the urad dal and millets separately in a mixer.
      </p>
      <p>
      Grind both to a smooth paste and mix both batters well after adding salt.
      </p>
      <p>
      Let it get fermented overnight or at least 8 hours.
      </p>
      <p>
      When the batter is well fermented, mix with a ladle.
      </p>
      <p>
      This can be refrigerated for at least 2 to 3 days.
      </p>
      <p>
      You can skip adding water at this stage.
      </p>
      <br />
      <p class="accordion-recipe-title">Instructions - For Making the Paniyaram</p>
      <p>
      When you are going to make the Paniyaram, take the required amount of batter you require.
      </p>
      <p>
      Check if the batter has the dosa consistency, add water if required.
      </p>
      <p>
      To the bowl, add finely chopped onions, grated carrot, green chilies.
      </p>
      <p>
      In a small pan, heat a tsp of cooking oil and temper with mustard, urad dal, chana dal, curry leaves, cumin and mix well.
      </p>
      <p>
      Pour this over the batter.
      </p>
      <p>
      Grease the Paniyaram pan with cooking oil, simmer and pour to fill the dents.
      </p>
      <p>
      Sprinkle few drops of oil, cover, and cook on low flame till the bottom gets cooked.
      </p>
      <p>
      Using the wooden stick flip to the other side.
      </p>
      <p>
      Cook till done, remove, and serve with side dishes.
      </p>
      </div>
      </div>`;

        var breakfast_accordions = document.getElementsByClassName(
          "accordion-breakfast"
        );

        for (var i = 0; i < breakfast_accordions.length; i++) {
          breakfast_accordions[i].onclick = function () {
            var content = this.nextElementSibling;
            if (content.style.maxHeight) {
              content.style.maxHeight = null;
            } else {
              content.style.maxHeight = content.scrollHeight + "px";
            }
          };
        }
        break;
      case "entree":
        entree.classList.add("active");
        breakfast.classList.remove("active");
        snack.classList.remove("active");
        dessert.classList.remove("active");

        // Adding Entree Recipes
        recipesList.innerHTML = `<div class="entree-recipes">
<h4 class="accordion-entree">Little Millet Soup</h4>
<div class="accordion-content-entree">
<img
src="https://cdn.shopify.com/s/files/1/0249/6233/4754/files/Millet_Soup_a0b3abe6-508e-45b5-9397-2175f24bae6d.jpg?v=1590707752"
alt="Little Millet Soup"
/>
<p class="accordion-recipe-title">Ingredients</p>
<ul>
<li>Little Millet Flour - 1/4 cup</li>
<li>Yogurt - 1 cup</li>
<li>Water - 3.5 cup</li>
<li>Sugar - 1 tsp</li>
<li>Corn - 1/4 cup boiled</li>
<li>Mixed color Bell Peppers chopped - 3 tbsp</li>
<li>Carrots finely chopped - 2 tbsp</li>
<li>Cilantro finely chopped - 1 cup</li>
<li>Ghee - 3 tsp</li>
<li>Cumin seeds - 1/2 tsp</li>
<li>Black pepper - 1/2 tsp (freshly crushed)</li>
<li>Green chillies - 1 or 1/2 (optional)</li>
</ul>
<br />
<p class="accordion-recipe-title">Instructions</p>
<p>
Mix Flour and yogurt until it is smooth. Add water and salt. Stir
constantly to avoid lumps. Slightly fry Chopped veggies in ghee in a
saucepan. Pour the mixture into large saucepan and bring it to boil. Keep
stirring to avoid curdling. Turn the flame low-medium and simmer for at
least 15-20 mins or until it thickens. Adjust the salt and pepper, add
sugar and vegetables. Mix it together and turn off the flame. Garnish with
cilantro. Millet soup is ready to serve. If it gets too thickened, you can
add hot water to make it to serving consistency.
</p>
</div>
<h4 class="accordion-entree">Kodo Millet Bisi Bele Bath</h4>
<div class="accordion-content-entree">
<img
src="https://cdn.shopify.com/s/files/1/0249/6233/4754/files/Kodo_Millet_Bisi_bella_bath.jpg?v=1590859549"
alt="KODO MILLET BISI BELE BATH"
/>
<p class="accordion-recipe-title">Ingredients</p>
<ul>
<li>Kodo Millet (soaked overnight) - 1 cup</li>
<li>Toor Dal - 3/4 cup</li>
<li>Carrots, Beans, Zucchini, Potato & Drum sticks - As required</li>
<li>Salt - As required</li>
<li>Tamarind Juice - As required</li>
<li>Coriander seeds - 1/4 cup</li>
<li>Urad Dal - 1/4 cup</li>
<li>Chana Dal - 1/4 cup</li>
<li>Dried Chillies - 8</li>
<li>Poppy seeds - 1 tbsp</li>
<li>Black Pepper - 1 tsp</li>
<li>Hing & Turmeric - a pinch</li>
<li>Cinnamon - 2 sticks</li>
<li>Dry Coconut - 1/2 cup</li>
</ul>
<br />
<p class="accordion-recipe-title">Instructions</p>
<p>
Boil Toor dal in 2 cups of water and add pinch of Turmeric to it. Once
it's half cooked, add all the vegetables & salt and keep cooking. Now add
the Kodo millet and keep cooking for about 10 mins. Dry roast the masala
ingredients and crush to powder. Grind 3 tbsp of this powder and grind
with grated coconut. In a pan add ghee, masala powder, mustard seeds,
curry leaves and tamarind juice and let it boil. Transfer it to the
cooking millet and add water for consistency. Let it cook in simmer for 5
mins. Garnish with curry leaves, boondi and serve hot.
</p>
</div>
<h4 class="accordion-entree">Millet Stir-Fry With Vegetables</h4>
<div class="accordion-content-entree">
<img
src="https://cdn.shopify.com/s/files/1/0509/7993/0283/files/Millet-stir-fry-with-vegetables.jpg?v=1622106631"
alt="MILLET STIR-FRY WITH VEGETABLES"
/>
<p class="accordion-recipe-title">Ingredients</p>
<ul>
<li>
1 cup
<a href="/products/pearled-little-millet">Bliss Tree’s little millet</a>
</li>
<li>2 cups of water</li>
<li>
1 tablespoon
<a href="/products/cold-pressed-peanut-oil">Bliss Tree’s Peanut Oil</a>
</li>
<li>2 cloves garlic minced</li>
<li>1-inch ginger grated</li>
<li>1 green chili slit</li>
<li>1 onion chopped</li>
<li>
1 cup chopped mixed vegetables i.e carrots, french beans, red and green
bell pepper
</li>
<li>
1 large head broccoli, cut into florets A handful of asparagus, tough
ends snapped off and sliced into 2-inch pieces
</li>
<li>1 tsp turmeric powder</li>
<li>2 tsp cumin powder</li>
<li>1 tsp coriander powder</li>
<li>Salt to taste</li>
<li>
1/2 tsp
<a href="/products/garam-masala">Bliss Tree’s Garam Masala Powder</a>
</li>
<li>Chopped fresh cilantro and red pepper flakes (For Garnish)</li>
</ul>
<br />
<p class="accordion-recipe-title">Instructions</p>
<p>
Wash the millet in a fine sieve under running water. Soak for 10 mins
while you prepare the vegetables.
</p>
<p>
Heat peanut oil or vegetable oil in a pan. When the oil is hot, add
garlic, green chili, and ginger. Sauté for a minute.
</p>
<p>
Now add chopped onions, other vegetables, and 1 tsp turmeric powder, 2 tsp
cumin powder, 1 tsp coriander powder, salt to taste. Mix well and cook for
2 minutes.
</p>
<p>
Drain the millet and add to the pan. Add 2 cups of water (you can also use
vegetable stock for added flavor) and cook on medium-high heat till there
is a boil.
</p>
<p>
Reduce the heat to low and cook covered, with a little opening, till all
the water is absorbed and the millet is cooked through.
</p>
<p>
Your millet stir-Fry with vegetable fry is ready to serve. Garnish it with
some fresh cilantro leaves, a sprinkle of red pepper flakes.
</p>
</div>
<h4 class="accordion-entree">Millet Veggie Burger</h4>
<div class="accordion-content-entree">
<img
src="https://cdn.shopify.com/s/files/1/0509/7993/0283/files/RidiculouslyHealthyMilletBurgers3676.jpg?v=1624359535"
alt="MILLET VEGGIE BURGER RECIPE"
/>
<p class="accordion-recipe-title">Ingredients</p>
<ul>
<li>1 1/2 cup water</li>
<li>1 large onion, finely chopped</li>
<li>2 small zucchinis</li>
<li>2 stalks celery, minced</li>
<li>2 finely grated carrot</li>
<li>2 tsp. sea salt</li>
<li>1 tablespoon chopped parsley</li>
<li>1 teaspoon chopped thyme</li>
<li>1 T. cumin</li>
<li>1 clove minced garlic</li>
<li>1/2 tsp. Bliss Tree chili powder</li>
<li>1/4 teaspoon ground pepper</li>
<li>
1 tablespoon
<a href="/products/cold-pressed-coconut-oil"
>Bliss Tree extra-virgin coconut oil</a
>
</li>
<li>1 large egg, lightly whisked</li>
<li>
1 1/2 cups millet flour (<a href="/products/kodo-millet-flour"
>Bliss Tree Kodo Millet Flour</a
>/
<a href="/products/little-millet-flour"
>Bliss Tree Little Millet Flour</a
>/
<a href="/products/ragi-finger-millet-flour-1"
>Bliss Tree Ragi Millet Flour</a
>)
</li>
</ul>
<br />
<p class="accordion-recipe-title">Instructions</p>
<p>
In a large bowl, combine millet flour (Bliss Tree Kodo Millet Flour/ Bliss
Tree Little Millet Flour/ Bliss Tree Ragi Millet Flour), onion, garlic,
carrot, zucchini, celery, cumin, thyme, parsley, coconut oil and mix well.
Add egg and mix it well; season with salt, chili powder, and pepper.
</p>
<p>
Using a 1/2 cup dry measuring cup, scoop out millet mixture and lightly
pack. Turn out onto the work surface and flatten to make a burger patty.
Repeat the process for making more burgers.
</p>
<p>
Heat a large skillet over medium-high heat. Add Bliss Tree Extra Virgin
Coconut Oil. When the oil is heated, add burger patty, working in batches
if necessary. Cook, gently turning once, until a golden crust has formed
on the bottom, 8 to 10 minutes per side. Alternatively, the burgers may be
baked in a 375-degree oven on a baking sheet for 30 minutes.
</p>
<p>Serve on hamburger buns with lettuce, tomato, and a dollop of mayo.</p>
</div>
</div>
`;

        var entree_accordions =
          document.getElementsByClassName("accordion-entree");

        const hideEntreeAccordion = () => {
          var accordions_content = document.getElementsByClassName(
            "accordion-content-entree"
          );
          for (var i = 0; i < accordions_content.length; i++) {
            accordions_content[i].style.maxHeight = null;
          }
        };

        for (var i = 0; i < entree_accordions.length; i++) {
          entree_accordions[i].onclick = function () {
            // hideEntreeAccordion();
            var content = this.nextElementSibling;
            if (content.style.maxHeight) {
              content.style.maxHeight = null;
            } else {
              content.style.maxHeight = content.scrollHeight + "px";
            }
          };
        }
        break;
      case "snack":
        snack.classList.add("active");
        breakfast.classList.remove("active");
        entree.classList.remove("active");
        dessert.classList.remove("active");

        // Adding Snack Recipes
        recipesList.innerHTML = `<div class="snacks-recipes">
<h4 class="accordion-snacks">Little Millet Murukku/Chakali</h4>
<div class="accordion-content-snacks">
<img
src="https://cdn.shopify.com/s/files/1/0249/6233/4754/files/IMG-20200527-WA0000_5962cd62-74b4-4630-bbca-592960d94389.jpg?v=1590707612"
alt="LITTLE MILLET MURUKKU/CHAKALI"
/>
<p class="accordion-recipe-title">Ingredients</p>
<ul>
<li>Little Millet Flour - 1 cup</li>
<li>Besan - 1/2 cup</li>
<li>Hot Oil or Butter - 1 tsp</li>
<li>Salt - As required</li>
<li>Chili Powder - As required</li>
<li>Sesame seeds - As required</li>
<li>Water - As required</li>
</ul>
<br />
<p class="accordion-recipe-title">Instructions</p>
<p>
Mix all ingredients to form a semi-thick consistency and leave it for an hour. Use Murukku maker to press and deep fry.
</p>
</div>
<h4 class="accordion-snacks">Jaggery Roti</h4>
<div class="accordion-content-snacks">
    <img src="https://cdn.shopify.com/s/files/1/0509/7993/0283/files/jaggery-roti-recipe_2.jpg?v=1632841694"
        alt="JAGGERY Roti" />
    <p class="accordion-recipe-title">Ingredients</p>
    <ul>
        <li>1/2 cup <a href='/products/2kgjaggery-powder-naattu-sakkarai'>Bliss Tree Jaggery Powder</a></li>
        <li>1/2 cup water or 2 tablespoons water</li>
        <li>1 to 1.25 cups whole wheat flour</li>
        <li>1 teaspoon fennel seeds</li>
        <li>1 tablespoon Ghee or 1 tablespoon <a href='/products/cold-pressed-peanut-oil'>Cold-Pressed Peanut Oil</a>
        </li>
        <li>2 tablespoon desiccated coconut - optional</li>
        <li>Ghee (clarified butter) as required, for roasting</li>
    </ul>
    <br />
    <p class="accordion-recipe-title">Instructions - For Kneading Dough</p>
    <p>
        In a bowl take ½ cup jaggery powder and ⅛ cup water (2 tablespoons water). You can also use grated jaggery
        instead of
        jaggery powder.
    </p>
    <p>
        Mix well and keep aside for 30 to 45 minutes or till all the jaggery dissolves.
    </p>
    <p>
        In another bowl or pan, take 1 to 1.25 cups of whole wheat flour. Also, add 1 teaspoon fennel seeds (saunf) and
        1
        tablespoon ghee.
    </p>
    <p>
        First stir the jaggery solution and then using a strainer strain it directly into the bowl containing flour.
    </p>
    <p>
        Mix very well first.
    </p>
    <p>
        Then begin to knead and make a smooth dough. The dough will be slightly sticky due to jaggery in it. If the
        dough looks wet, then you can add some more whole wheat flour and knead.
    </p>
    <br />
    <p class="accordion-recipe-title">Instructions - For Rolling Jaggery Roti</p>
    <p>
        Now take a zip lock bag. You can also take a small sized banana leaf. Spread some ghee on the zip lock bag.
    </p>
    <p>
        Take a medium-sized ball from the dough and place it on the zip lock bag.
    </p>
    <p>
        With a rolling pin, roll to a small roti similar to a poori size. Just that the roti has to be slightly thick
        than a
        stuffed paratha.
    </p>
    <br />
    <p class="accordion-recipe-title">Instructions - For Cooking Jaggery Roti</p>
    <p>
        Now gently remove the roti from the zip lock bag and place it on a hot tawa. Keep the flame to low or low-medium
        and
        begin to roast the jaggery roti.
    </p>
    <p>
        When one side is a bit browned, then flip it.
    </p>
    <p>
        Spread some ghee on the top. These gud ki rotis absorb ghee like anything. So make sure you don't go overboard
        with the
        ghee. You can also use a neutral-flavored oil instead of ghee.
    </p>
    <p>
        Flip the roti, when the second side is browned.
    </p>
    <p>
        Spread some ghee on this side too.
    </p>
    <p>
        With a spatula press the edges as well as center so that the roti gets cooked evenly.
    </p>
    <p>
        Flip a couple of times to get an evenly cooked and roasted jaggery roti. Remove and serve hot. You can also
        stack gud ki
        rotis in a roti basket and serve them warm. Make all rotis this way.
    </p>
    <p>
        Serve jaggery roti plain or with fresh curd or white butter.
    </p>
    <br />
    <br />
    <p class="accordion-recipe-title">#Blissful Tips</p>
    <p>
        If the dough becomes very sticky or wet then add some flour.
    </p>
    <p>
        Don't roll the rotis very thin. They are a little thicker than stuffed parathas.
    </p>
    <p>
        You can also add 2 tablespoons of desiccated coconut.
    </p>
    <p>
        Cook the rotis on a low flame.
    </p>
    <p>
        Instead of ghee, you can use <a href='/products/cold-pressed-peanut-oil'>Cold-Pressed Peanut Oil</a>
    </p>
</div>
</div>`;

        var snacks_accordions =
          document.getElementsByClassName("accordion-snacks");

        const hideSnacksAccordion = () => {
          var accordions_content = document.getElementsByClassName(
            "accordion-content-snacks"
          );
          for (var i = 0; i < accordions_content.length; i++) {
            accordions_content[i].style.maxHeight = null;
          }
        };

        for (var i = 0; i < snacks_accordions.length; i++) {
          snacks_accordions[i].onclick = function () {
            // hideSnacksAccordion();
            var content = this.nextElementSibling;
            if (content.style.maxHeight) {
              content.style.maxHeight = null;
            } else {
              content.style.maxHeight = content.scrollHeight + "px";
            }
          };
        }
        break;
      case "dessert":
        dessert.classList.add("active");
        snack.classList.remove("active");
        breakfast.classList.remove("active");
        entree.classList.remove("active");

        // Adding Dessert Recipes
        recipesList.innerHTML = `<div class="desserts-recipes">
    <h4 class="accordion-desserts">Barnyard Millet Jaggery Payasam</h4>
    <div class="accordion-content-desserts">
      <img
        src="https://cdn.shopify.com/s/files/1/0509/7993/0283/files/Jhangora_ki_Kheer_Barnyard_Millet_Kheer_Recipe-4.jpg?v=1629191609"
        alt="Barnyard Millet Jaggery Payasam"
      />
      <p class="accordion-recipe-title">Ingredients</p>
      <ul>
        <li><a href="/products/5kgbarnyard-millet-raw">Bliss Tree Barnyard Millet</a>, broken - 1/2 cup</li>
        <li>Milk - 2 cups</li>
        <li><a href="/products/1kgjaggery">Bliss Tree's Jaggery</a> - 1/4 cup</li>
        <li>3 Cardamom (Elaichi) Pods/Seeds</li>
        <li>10 Cashew nuts</li>
        <li>2 Tablespoon Ghee</li>
      </ul>
      <br />
      <p class="accordion-recipe-title">Instructions</p>
      <p>Step 1: To begin preparing, pressure cook the barnyard millet in a pressure cooker with 1 cup of water for up to 5 whistles. It takes around 20 minutes to cook the millet. After that, allow the pressure to release and place the Barnyard Millet aside.</p>
      <p>Step 2: Heat a pan with milk on low/medium heat. Add crushed cardamom seeds and jaggery into the milk and let it boil. Add cooked millet in it and simmer the Barnyard Millet Jaggery Payasam for around 20 minutes until it thickens and achieves a creamy texture.</p>
      <p>Step 3: When the desired consistency is reached, turn off the heat. Then heat a small skillet and add 2 tablespoons of ghee and also add cashew nuts and toast it until it is golden brown on low/medium heat.</p>
      <p>Step 4: Once cashew nuts are roasted, spoon it over the Barnyard Millet Jaggery Payasam and serve.</p>
    </div>
  </div>`;

        var desserts_accordions =
          document.getElementsByClassName("accordion-desserts");

        for (var i = 0; i < desserts_accordions.length; i++) {
          desserts_accordions[i].onclick = function () {
            var content = this.nextElementSibling;
            if (content.style.maxHeight) {
              content.style.maxHeight = null;
            } else {
              content.style.maxHeight = content.scrollHeight + "px";
            }
          };
        }
        break;

      default:
        console.log("Error!");

        // Adding No Recipes
        recipesList.innerHTML = "";
        break;
    }
  }
  function breakfastListener() {
    changeSelectedCategory("breakfast");
  }
  function entreeListener() {
    changeSelectedCategory("entree");
  }
  function snackListener() {
    changeSelectedCategory("snack");
  }
  function dessertListener() {
    changeSelectedCategory("dessert");
  }